export const he = {
    translation: {
        'Booking System': 'מערכת הזמנות',
        'Registration for Shabbat & Holidays': 'הרשמות לשבת וחג',
        'When will you be joining us':'למתי תרצו להירשם?',
        'register': 'הרשמה',
        'Registration is quick and easy in a few simple steps': 'הרשמה קלה ומהירה בכמה צעדים פשוטים',
        'Back': 'חזור',
        'Location': 'מיקום',
        'first_name': 'שם פרטי',
        'last_name': 'שם משפחה',
        'email': 'דואר אלקטרוני',
        'phone': 'טלפון',
        'I would like to donate': 'אשמח לתרום',
        'Your donation': 'התרומה שלך',
        'Payment Method': 'אמצעי תשלום',
        'Credit Card': 'כרטיס אשראי',
        'Cash': 'מזומן',
        'I have read and agreed to the terms of the': 'קראתי והסכמתי',
        'Terms and Conditions': 'לתנאי השימוש',
        'total': 'סה״כ',
        'continue': 'המשך',
        'Thank You' : 'תודה רבה',
        'Your order has been successfully received' : 'הזמנתך התקבלה בהצלחה',
        'places left' : 'מקומות פנויים',
        'No spots available': 'אין מקומות פנויים',
        'coupon': 'קופון',
        'off': 'הנחה',
    }
}